import { render, staticRenderFns } from "./today_orders.vue?vue&type=template&id=a4443dfe&scoped=true&"
import script from "./today_orders.vue?vue&type=script&lang=js&"
export * from "./today_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4443dfe",
  null
  
)

export default component.exports